import React from "react";
import SkeletonIconGridItem from "./SkeletonIconGridItem";

export const getIconSkeletonGridContent = ({ numberOfItems }) => {
    const content = new Array(numberOfItems).fill(<SkeletonIconGridItem />);
    return content;
};
